import React from "react";
import imgLogo from "./_img/logo.svg";
import imgBogen from "./_img/bogen.svg";
import {gql, useQuery} from "@apollo/client";

const GQ = gql`query Header {
    getConfig {
        id
        testsystem
    }
}`;

interface HeaderResponse {
    getConfig: {
        testsystem: Boolean
    }
}

function Header() {

    const {loading, error} = useQuery<HeaderResponse>(GQ);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error :(</p>;

    return (
        <div className="container-fluid header">
            <div className="row">
                <div id="logo-container" className="col-sm-4 bg-green d-flex justify-content-between">
                    <div className="d-flex w-100 justify-content-center">
                        <img id="logo" className="img-fluid  p-2" alt="Logo" src={imgLogo}/>
                    </div>

                    <img id="bogen" src={imgBogen} alt=""/>
                </div>
                <div className="col-sm-8 bg-primary">
                    <div className="header-content">
                        <div id="header-title">CIRS-LAS Portal</div>
                        <div id="header-subtitle">Critical incident reporting system in laboratory animal science</div>
                        <div id="header-slogan">Refine - Reduce - Replace</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;